// client/src/components/common/IconButton.jsx
//
// A bare clickable icon: no border, background or visible text. The label is
// the accessible name and hover tooltip, since nothing else names the button.
import React from 'react';
import { FaSync } from 'react-icons/fa';
import './IconButton.css';

export default function IconButton({ label, className = '', children, ...rest }) {
  return (
    <button
      type="button"
      className={`icon-btn ${className}`.trim()}
      aria-label={label}
      title={label}
      {...rest}
    >
      {children}
    </button>
  );
}

export function RefreshButton({ label = 'Refresh', loading = false, disabled = false, ...rest }) {
  return (
    <IconButton label={label} disabled={disabled || loading} aria-busy={loading || undefined} {...rest}>
      <FaSync className={loading ? 'icon-btn__spin' : undefined} aria-hidden="true" />
    </IconButton>
  );
}
